import { z } from 'zod';
import { ID } from '../../utils/codecUtils';

export const deleteRelation = (relationId: ID) => {
  return {
    endpoint: `/relations/${relationId}`,
    method: 'DELETE',
    responseSchema: z.unknown(),
  } as const;
};
